import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '..';
import { CONTROLLERS, ENDPOINTS } from '../../constants';
import { Response, Terminal } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class TerminalService {
  private api: string = CONTROLLERS.PAYMENTS.TERMINAL;
  constructor(private apiService: ApiService) {}

  getListByPracticeId(practiceId: number): Observable<Response<Terminal[]>> {
    return this.apiService.getById(
      practiceId.toString(),
      `${this.api}/${ENDPOINTS.PAYMENTS.TERMINAL.GET_TERMINAL}`
    );
  }

  createTerminal(body: Terminal): Observable<Response<any>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.PAYMENTS.TERMINAL.CREATE_TERMINAL}`,
      body
    );
  }

  updateTerminal(body: Terminal): Observable<Response<any>> {
    return this.apiService.put(
      '',
      `${this.api}/${ENDPOINTS.PAYMENTS.TERMINAL.UPDATE_TERMINAL}`,
      body
    );
  }

  deleteTerminal(terminalId: number): Observable<Response<any>> {
    return this.apiService.delete(
      terminalId.toString(),
      `${this.api}/${ENDPOINTS.PAYMENTS.TERMINAL.UPDATE_TERMINAL}`
    );
  }
}
